/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconSearch16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconSearch16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.507 11.45a5.667 5.667 0 1 1 .943-.943l3.218 3.219-.943.943-3.218-3.218ZM11.332 7a4.333 4.333 0 1 1-8.667 0 4.333 4.333 0 0 1 8.667 0Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconSearch24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconSearch24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.762 17.176a8.5 8.5 0 1 1 1.414-1.414l4.827 4.827-1.414 1.414-4.827-4.827ZM17 10.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconSearch = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconSearch(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '16':
            return <IconSearch16 {...iconProps} />;
        case '24':
            return <IconSearch24 {...iconProps} />;
        default:
            return <IconSearch24 {...iconProps} />;
    }
});
